module.exports = __webpack_public_path__ + "static/media/view1.432bb28a.jpg";